import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "multiplierModal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  for: "name",
  class: "form-label fw-bold"
}
const _hoisted_9 = { class: "is-invalid" }
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = {
  for: "multiplier",
  class: "form-label fw-bold"
}
const _hoisted_12 = { class: "is-invalid" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "form-label fw-bold" }
const _hoisted_15 = { class: "row g-2 align-items-center" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = {
  for: "start",
  class: "form-label"
}
const _hoisted_18 = { class: "is-invalid" }
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = {
  for: "end",
  class: "form-label"
}
const _hoisted_21 = { class: "is-invalid" }
const _hoisted_22 = { class: "modal-footer" }
const _hoisted_23 = {
  type: "button",
  class: "btn btn-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_24 = {
  type: "submit",
  class: "btn btn-primary"
}

import { DynamicMultiplier } from '@/types/DynamicMultiplier';
import { ErrorMessage, Form, Field } from 'vee-validate';
import { ref } from 'vue';
import * as yup from 'yup';
import {useSettingsStore} from "@/services/stores/SettingsStore";
import { storeToRefs } from 'pinia';
import SettingsRepository from '@/repositories/SettingsRepository';
import { Modal } from 'bootstrap';


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateMultiplierModal',
  setup(__props) {

const { rideFees } = storeToRefs(useSettingsStore());
const schema = yup.object().shape({
  name: yup.string().required().min(3),
  multiplier: yup.number().required().min(1).max(5),
  timeRanges: yup.object().shape({
    start: yup.string().required(),
    end: yup.string().required()
  })
})

const multiplier = ref<DynamicMultiplier>({
  timeRanges: {
    start: '00:00',
    end: '00:00'
  },
  multiplier: 1,
  name: '',
});

const saveMultiplier = (values: any) => {
    if (!rideFees.value) {
        return
    }
    if (!rideFees.value.dynamic_multipliers) {
        rideFees.value.dynamic_multipliers = [];
    }
    
    const multiplierData: DynamicMultiplier = {
        name: values.name,
        multiplier: values.multiplier,
        timeRanges: {
            start: values.timeRanges.start,
            end: values.timeRanges.end
        }
    };
    
    SettingsRepository.addMultiplier(rideFees.value.dynamic_multipliers, multiplierData)
        .then(() => {
            multiplier.value = {
                timeRanges: {
                    start: '00:00',
                    end: '00:00'
                },
                multiplier: 1,
                name: ''
            };
            const modal = document.getElementById('multiplierModal');
            if (modal) {
                const bootstrapModal = Modal.getInstance(modal);
                bootstrapModal?.hide();
            }
        });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Form), {
          onSubmit: saveMultiplier,
          "validation-schema": _unref(schema),
          class: "needs-validation",
          novalidate: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.$t('settings.fees.actions.add_multiplier')), 1),
              _cache[4] || (_cache[4] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.fields.name')), 1),
                _createVNode(_unref(Field), {
                  name: "name",
                  type: "text",
                  class: "form-control form-control-sm",
                  id: "name",
                  modelValue: multiplier.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((multiplier.value.name) = $event)),
                  placeholder: _ctx.$t('common.fields.name')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(ErrorMessage), { name: "name" }, {
                  default: _withCtx(({ message }) => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(message), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('settings.fees.fields.multiplier')), 1),
                _createVNode(_unref(Field), {
                  name: "multiplier",
                  type: "number",
                  class: "form-control form-control-sm",
                  id: "multiplier",
                  modelValue: multiplier.value.multiplier,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((multiplier.value.multiplier) = $event)),
                  placeholder: _ctx.$t('settings.fees.fields.multiplier')
                }, null, 8, ["modelValue", "placeholder"]),
                _createVNode(_unref(ErrorMessage), { name: "multiplier" }, {
                  default: _withCtx(({ message }) => [
                    _createElementVNode("span", _hoisted_12, _toDisplayString(message), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('settings.fees.fields.time_range')), 1),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t('settings.fees.fields.start_time')), 1),
                    _createVNode(_unref(Field), {
                      name: "timeRanges.start",
                      type: "time",
                      class: "form-control form-control-sm",
                      id: "start",
                      modelValue: multiplier.value.timeRanges.start,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((multiplier.value.timeRanges.start) = $event)),
                      placeholder: _ctx.$t('settings.fees.fields.start_time')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode(_unref(ErrorMessage), { name: "timeRanges.start" }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(message), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('settings.fees.fields.end_time')), 1),
                    _createVNode(_unref(Field), {
                      name: "timeRanges.end",
                      type: "time",
                      class: "form-control form-control-sm",
                      id: "end",
                      modelValue: multiplier.value.timeRanges.end,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((multiplier.value.timeRanges.end) = $event)),
                      placeholder: _ctx.$t('settings.fees.fields.end_time')
                    }, null, 8, ["modelValue", "placeholder"]),
                    _createVNode(_unref(ErrorMessage), { name: "timeRanges.end" }, {
                      default: _withCtx(({ message }) => [
                        _createElementVNode("span", _hoisted_21, _toDisplayString(message), 1)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", _hoisted_23, _toDisplayString(_ctx.$t('common.actions.cancel')), 1),
              _createElementVNode("button", _hoisted_24, _toDisplayString(_ctx.$t('common.actions.submit')), 1)
            ])
          ]),
          _: 1
        }, 8, ["validation-schema"])
      ])
    ])
  ]))
}
}

})